import { TextInput, type TextInputProps } from "@/components/admin/text-input";
import { formatPhone, validatePhone } from "./phone";
export function PhoneInput(props: TextInputProps) {
  const { validate, ...rest } = props;
  const validators = validate
    ? Array.isArray(validate)
      ? validate
      : [validate]
    : [];
  return (
    <TextInput
      {...rest}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder="+7 (999) 999-99-99"
      format={formatPhone}
      parse={formatPhone}
      validate={[...validators, validatePhone]}
    />
  );
}
